import React, { useEffect } from 'react';
import useFormReadOnlyStore from './FormConditionStores/useFormReadOnlyStore';
import ItemStatementCondition from './FormConditionComponents/ItemStatementReadOnly';

function FormConditional({ readonly, availablePlaceholders }) {
  useEffect(() => {
    if (readonly && readonly.Statement) {
      useFormReadOnlyStore.getState().setStatement(readonly);
      useFormReadOnlyStore.getState().setFormConditional(readonly);
    } else {
      useFormReadOnlyStore.getState().initialiseEmpty();
    }
  }, []);

  const { Condition } = useFormReadOnlyStore((s) => s.Statement.Statement.content);
  const AnswerList = useFormReadOnlyStore((s) => s.AnswerList);

  return (
    <div
      style={{
        boxShadow: '0px 2px 4px var(--mui-palette-action-focus)',
        padding: '15px 15px 30px',
        margin: '15px 0',
      }}
    >
      {Condition &&
        Condition.map((condition, index) => (
          <ItemStatementCondition
            condition={condition}
            indexStatement={index}
            key={index}
            AnswerList={AnswerList[index]}
            availablePlaceholders={availablePlaceholders}
          />
        ))}
    </div>
  );
}
export default FormConditional;
